import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  HContainer,
  Text
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../constants';

export const TextRow = (props) => {

  return (

    <HContainer
      margin={props.margin}
      width={'100%'}
      justifyContent={'space-between'}
      alignItems={props.alignItems}>

      <Text
        lineHeight={props.leftLineHeight}
        color={props.leftFontColor}
        fontWeight={props.leftFontWeight}
        fontSize={props.leftFontSize}>

        { props.leftText }
      </Text>

      <Text
        lineHeight={props.rightLineHeight}
        color={props.rightFontColor}
        fontWeight={props.rightFontWeight}
        fontSize={props.rightFontSize}>

        { props.rightText }
      </Text>
    </HContainer>
  );
};

// TODO: Add proptypes
TextRow.propTypes = {
  margin: PropTypes.string,
  alignItems: PropTypes.string,
  leftFontColor: PropTypes.string,
  leftFontSize: PropTypes.string,
  leftFontWeight: PropTypes.string,
  leftLineHeight: PropTypes.string,
  rightFontColor: PropTypes.string,
  rightFontSize: PropTypes.string,
  rightFontWeight: PropTypes.string,
  rightLineHeight: PropTypes.string
};

// TODO: Add default props
TextRow.defaultProps = {
  margin: '8px 0',
  alignItems: undefined,
  leftFontColor: CustomColors.Grey18,
  leftFontSize: '16px',
  leftFontWeight: 'normal',
  leftLineHeight: '20px',
  rightFontColor: CustomColors.Grey16,
  rightFontSize: '16px',
  rightFontWeight: 'bold',
  rightLineHeight: '20px'
};
